<template>
  <div class="row justify-content-center mt-2">
      <div class="p-2 w-100">
        <div class="">
          Your balance: {{ this.balance.toFixed(4) }} SOL
          <a href="#" class="small" @click="halfAmount">HALF</a>&nbsp;
          <a href="#" class="small" @click="maxAmount">MAX</a>

          <input type="text" class="form-control" v-model="amount" pattern="[0-9\.]*" min="0" >
          <div v-if="this.wallet.connected && ((balance - amount) < 0.01)" class="text-danger small">
            We advise keeping at least 0.01 SOL in your account to pay for transaction fees
          </div>
          <button class="btn btn-success btn-lg w-100 mt-1" @click="delegate" v-html="buttonText" :disabled="buttonState"></button>
        </div>
      </div>
  </div>
</template>

<script>
import {watchEffect, reactive, ref, unref, isProxy, toRaw} from "vue";
import { useWallet } from 'solana-wallets-vue';
import {
  Connection, Authorized, Keypair,
  Lockup, PublicKey,
  LAMPORTS_PER_SOL,
  sendAndConfirmRawTransaction, sendAndConfirmTransaction,
  StakeProgram, SystemProgram, Transaction,
  TransactionInstruction, AccountBalancePair, DelegateStakeParams, CreateStakeAccountParams
} from "@solana/web3.js";

// const connection = new Connection('https://wild.solanacompass.com/', 'confirmed')
const connection = new Connection('https://specific-lanny-fast-mainnet.helius-rpc.com/', 'confirmed')
// const connection = new Connection("https://purple-icy-resonance.solana-mainnet.quiknode.pro/d1cdf1c44eba5a2c3842d0e50c6dfeea25ea2001/", "confirmed");

export default {
  name: "DelegateStake",
  inject: ['moshaToast'],
  computed: {
    wallet() {
      return reactive(useWallet())
    },
    walletAddress() {
      return this.wallet.address
    },
    walletConnected() {
      return this.wallet.connected
    },
    buttonText() {
      if (!this.wallet.connected) return 'Connect Wallet'
      if (this.amount > this.balance) return 'Insufficient Balance'
      return 'Stake your SOL'
    },
    buttonState() {
      if (!this.wallet.connected) return 'disabled'
      if (this.amount > this.balance) return 'disabled'
      return false
    },
  },
  props: ['vote'],
  data() {
    return {
      amount: 0,
      balance: 0,
      voteKey: '',

    }
  },
  mounted() {
    this.getWalletBalance()
    // check balance every 3 seconds
    setInterval(() => {
        this.getWalletBalance()
    }, 3000)


    let voteEl = document.getElementById('voteAccount')
    if (voteEl) this.voteKey = voteEl.dataset.key
    else this.voteKey = this.vote || 'EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72'
  },
  watch: {

    walletConnected(now, prev) {
      console.log('wallet changed')
        console.log(this.wallet)
      if (this.wallet.connected) {
        this.getWalletBalance()
        // this.clicky('/stake/wallet-connected')
      } else {
        this.balance = 0
        // this.clicky('/stake/wallet-disconnected')

      }

    },
  },
  methods: {
    clicky: function (url) {
      if (typeof clicky === 'object') {
        // eslint-disable-next-line
        clicky.log(url)
          clicky.goal("Delegated Stake",this.amount)
      }
    },
    maxAmount() {
       this.amount = Math.max(this.balance - 0.01,0)
    },
    halfAmount() {
      this.amount = Math.max(this.balance / 2,0)
      console.log(this.balance / 2)
    },
    getWalletBalance() {
      if (!this.wallet.connected) return

// also get balance for Solana
      const solanaMint = 'So11111111111111111111111111111111111111112'
      const solanaBalance = connection.getBalance(this.wallet?.publicKey).then((bal) => {
        // balances[solanaMint] = bal / (10 ** 9)
        this.balance = (bal / (10 ** 9)) || 0
      })


    },
    async createStakeAccount(sol) {

      const solToLamport = sol * 1000000000;
      if (this.wallet.publicKey instanceof PublicKey) {
        const isValid = this.balance >= this.amount;
        if (isValid) {
          const minimumAmount = await connection.getMinimumBalanceForRentExemption(
              StakeProgram.space,
          );
          const fromPubkey = this.wallet.publicKey;
          const newStakeAccount = new Keypair();
          const authorizedPubkey = this.wallet.publicKey;
          const authorized = new Authorized(authorizedPubkey, authorizedPubkey);
          const lockup = new Lockup(0, 0, fromPubkey);
          const lamports = minimumAmount + solToLamport;
          const stakeAccountIns = {
            fromPubkey,
            stakePubkey: newStakeAccount.publicKey,
            authorized,
            lockup,
            lamports
          }
          const newStakeAccountIns = StakeProgram.createAccount(stakeAccountIns)
          return {newStakeAccountIns, newStakeAccount}

        }
      }
    },
    async delegate() {
      if (this.wallet.publicKey instanceof PublicKey) {
        try {

          await this.createStakeAccount(this.amount).then(r => {

            const stakeAcc = r?.newStakeAccount;
            const instruction = {
              stakePubkey: stakeAcc.publicKey,
              authorizedPubkey: new PublicKey(this.wallet.publicKey),
              votePubkey: new PublicKey(this.vote || 'EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72')
            }
            const stakeAccIns = r?.newStakeAccountIns;
            const stake = [stakeAccIns, StakeProgram.delegate(instruction)]
            this.sendTx(stake, [stakeAcc])

          })
        } catch (error) {
      //   this.$honeybadger.notify(error)
          console.log(error)
        }
      }
    }
    ,
    async sendTx(txParam, extraSigners = []) {

      this.loading = true
      try {
        const {blockhash} = await connection.getRecentBlockhash('recent');
        let transaction = new Transaction({
          feePayer: this.wallet.publicKey,
          recentBlockhash: blockhash
        }).add(...txParam);
        if (typeof this.wallet.signTransaction !== 'undefined') {
            console.log(transaction)
            transaction.signers = extraSigners
            // this.wallet.sendTransaction(transaction, connection )
          transaction = await this.wallet.signTransaction(transaction);
          // LMT: add extra signers (fix create-token-account problem)
          if (extraSigners) transaction.partialSign(...extraSigners);
          //LMT: check null signatures
          for (let i = 0; i < transaction.signatures.length; i++) {
            if (!transaction.signatures[i].signature) {
              throw Error(`missing signature for ${transaction.signatures[i].publicKey.toString()}. Check .isSigner=true in tx accounts`)
            }
          }
          console.log(transaction)
          const rawTransaction = transaction.serialize({requireAllSignatures: false});
          console.log(rawTransaction)
          const txid = await connection.sendRawTransaction(rawTransaction);
          this.toast(`transaction: ${txid}`, 'info', () => {
            window.open(`https://explorer.solana.com/tx/${txid}?cluster=${process.env.REACT_APP_NETWORK}`)
          })
           // check balance in 500ms
            setTimeout(() => {
                this.getWalletBalance()
            }, 1500)
          await connection.confirmTransaction(txid, 'confirmed');
          this.toast('Stake Account Created', 'success')
            axios.post('/log/stake', {
                txid: txid,
                staker: this.wallet.publicKey,
                amount: this.amount *1e9,

                wallet: this.wallet.wallet.adapter.name,
                stake_to: this.voteKey
            })
          if (typeof clicky === 'object') {

            // eslint-disable-next-line
            clicky.goal('Delegated Stake', this.amount)
          }
        }
      } catch (error) {
        this.toast('Failed to configure stake account', 'error')
       // this.$honeybadger.notify(error)
      }
      this.loading = false
    },
    toast(msg, type) {
      this.moshaToast(msg,
          {
            type: type,
            showIcon: 'true',
            transition: 'bounce',
            position: 'top-left',
          })
    },
  }
}

</script>

<style scoped>

</style>
